
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1557499447662",
    "class": "icon",
    "style": "",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1230",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M511.7 954.4H783s-13.6-189.1-199.6-218.6c-50.7-3.7-72.9-2.2-72.9-2.2v0.2c0.1 200.8 1.2 220.6 1.2 220.6z",
        "fill": "#FFFFFF",
        "p-id": "1231"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M511.7 954.4H241.5S255 765 440.2 735.6c50.4-3.7 72.6-2.2 72.6-2.2v0.2c0.1 201-1.1 220.8-1.1 220.8z",
        "fill": "#E0ECFF",
        "p-id": "1232"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M439.4 609.1h145.1v257.2H439.4V609.1z",
        "fill": "#FFDDB8",
        "p-id": "1233"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M439.4 604.6h145.1v45.1l-145.1 88V604.6z",
        "fill": "#E5C6A5",
        "p-id": "1234"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M501.6 887.4h17.9v67h-17.9v-67z",
        "fill": "#774B4B",
        "p-id": "1235"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M510.6 954.1s31.1 0.2 45.8 0.2c6.1-9.7 77.6-200.1 77-203.1-0.3-1.8-93.8 17.8-93.8 17.8l-29 30.8v154.3z",
        "fill": "#FFFFFF",
        "p-id": "1236"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512.8 954.4s-31.1 0.2-45.8 0.2c-6.1-9.7-77.6-199.8-77-202.9 0.3-1.8 96 17.3 96 17.3l26.8 31.3v154.1z",
        "fill": "#E0ECFF",
        "p-id": "1237"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M507 206.3v442.2c61-3 134.9-43.3 169.6-107.9 17.8-33.2 19.4-71.3 19.4-112.8-0.1-122.4-80.9-221.5-189-221.5z",
        "fill": "#FFDDB8",
        "p-id": "1238"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M696 456.9l-185.4-27.3v218.8c60-3 132.7-43.3 166.8-107.9 13.4-25.3 17.4-53.4 18.6-83.6z",
        "fill": "#FFFFFF",
        "p-id": "1239"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M510.6 206.3v442.2c-59.8-3-132.3-43.3-166.4-107.9-17.5-33.2-19-71.3-19-112.8 0-122.4 79.3-221.5 185.4-221.5z",
        "fill": "#F5D4B1",
        "p-id": "1240"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M325.7 456.9l184.9-27.3v218.8c-59.8-3-132.3-43.3-166.4-107.9-13.3-25.3-17.4-53.4-18.5-83.6z",
        "fill": "#E0ECFF",
        "p-id": "1241"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M340.2 402.8c3.4-50.5 26.8-108.5 105.6-140.7 19 4.3 58.6 37.5 129 4.5 47.9-22.4 108.1 77.3 116.7 118.3 6.9 32.8-6.5 29.4 15.6 22.3 5-3.9 38-54.2-13.4-256.8C589.9 62 506.1 70 506.1 70s-131.8 14.3-192 116.1c-16.6 90-20.3 158.6-8.4 208.3 11.1-27.6 24.8-16 34.5 8.4z",
        "fill": "#5C3E31",
        "p-id": "1242"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M514.1 250.9H303s-6.8 41.1-6.8 44.7 2.3 46.9 2.3 46.9h216.3c-0.6-19.3-0.7-47.8-0.7-91.6z",
        "fill": "#E0ECFF",
        "p-id": "1243"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512.1 250.9h206.2s6.7 41.1 6.7 44.7-2.3 46.9-2.3 46.9H511.5c0.6-19.3 0.6-47.8 0.6-91.6z",
        "fill": "#FFFFFF",
        "p-id": "1244"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M308 374.4c-11.9 4.1-15.3 26.1-7.7 49.2 7.7 23.1 23.6 38.5 35.5 34.4s15.3-26.1 7.7-49.2c-7.7-23.1-23.6-38.5-35.5-34.4z",
        "fill": "#F5D4B1",
        "p-id": "1245"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M715.3 375.3c11.9 4 15.3 25.7 7.7 48.5-7.7 22.8-23.6 38-35.5 34s-15.3-25.7-7.7-48.5c7.7-22.8 23.5-38 35.5-34z",
        "fill": "#FFDDB8",
        "p-id": "1246"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M407 745.5v106.3c0 8.4 6.8 15.2 15.2 15.2h177.1c8.4 0 15.2-6.8 15.2-15.2V745.5h12.7v108.8c0 14-11.3 25.3-21.9 27H423c-17.4-1.7-28.7-13-28.7-27V745.5H407z",
        "fill": "#666666",
        "p-id": "1247"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M586.5 697.5l77.2 24.7 36.7 93.9-162.6-45.8 48.7-72.8zM440.7 701l-76.8 24.6-36.5 93.7 161.8-45.7-48.5-72.6z",
        "fill": "#FFFFFF",
        "p-id": "1248"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M501.2 867.7h20.4V956h-20.4z",
        "fill": "#666666",
        "p-id": "1249"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M513.9 226.4c36.4 0 65.9 29.5 65.9 65.9s-29.5 65.9-65.9 65.9-65.9-29.5-65.9-65.9 29.5-65.9 65.9-65.9z",
        "fill": "#CCCCCC",
        "p-id": "1250"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M515 246.5c25.9 0 46.9 21 46.9 46.9s-21 46.9-46.9 46.9-46.9-21-46.9-46.9 21-46.9 46.9-46.9z",
        "fill": "#333333",
        "p-id": "1251"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M470.3 307.5c-1.4-4.5-2.2-9.2-2.2-14.1 0-25.9 21-46.9 46.9-46.9 16.2 0 30.6 8.3 39 20.8l-83.7 40.2z",
        "fill": "#666666",
        "p-id": "1252"
      }
    }
  ]
})
    }
  